import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';

// Services
import { SharedService } from 'src/app/services/shared.service';
import { LoginInvitedService } from 'src/app/services/login-invited/login-invited.service';
import { LoginService } from 'src/app/services/login/login.service';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

import toastr from "toastr";

@Component({
    selector: 'app-login-user-invited',
    templateUrl: './login-user-invited.component.html',
    styleUrls: ['./login-user-invited.component.sass'],
    standalone: false
})
export class LoginUserInvitedComponent implements OnInit {

  showLogin: boolean = false;
  optSelected: number = 1;

  listIndicatives: any[];
  indicativeSelected: string = '57';
  statusSelectIndicative: boolean = false;

  numberPhone: string = '';
  phoneValid: boolean = false;

  termsAndConditions: boolean = false;

  // codigo
  code1: string = '';
  code2: string = '';
  code3: string = '';
  code4: string = '';
  code5: string = '';
  codeValid: number = 1;
  resendCode: number = 60;

  //[formControl]="address1"
  addressName = new FormControl('');
  addressNameUser = new FormControl('');
  addressDescription = new FormControl('');

  constructor(
    private _sharedService: SharedService,
    private _loginInvitedService: LoginInvitedService,
    private _loginService: LoginService,
    private _checkoutService: CheckoutService,
    private _amplitudeService: AmplitudeService,
  ) {
    this.listIndicatives = this._sharedService.getListIndicatives();
  }

  ngOnInit(): void {
    this._amplitudeService.emmiterLogEvent('OPEN_LOGIN_CHECKOUT', {});
  }

  async getCode() {
    if (this.termsAndConditions) {
      this._sharedService.emmiterShowLoader(true);
      let data = {
        indicative: '+' + this.indicativeSelected,
        phone: this.numberPhone
      };
      let response: any = await this._loginInvitedService.getCode(data).toPromise().catch((err: any) => this.handleError(err));
      if( response ){
        this._amplitudeService.emmiterLogEvent('SUCCESS_CODE_GENERATED', {});
        this.optSelected = 2;
        this._sharedService.emmiterShowLoader(false);
        this.countdown();
      }
    } else toastr.warning('Debe aceptar los términos y condiciones.');
  }

  handleError(error: HttpErrorResponse): void {
    if(error.error.message) console.log(error.error.message);
    if(error.status == 404) {
      // this._amplitudeService.emmiterLogEvent('UNREGISTERED_USER', {});
      toastr.warning('Usuario no registrado.');
    }
    if(error.error.message) toastr.warning(error.error.message);
    this._sharedService.emmiterShowLoader(false)
  }

  countdown(): void {
    this.resendCode = 60;
    let interval = setInterval(() => {
      this.resendCode --;
      if(this.resendCode == 0) clearInterval(interval);
    } , 1000);
  }

  async getSmsCode() {
    if (this.termsAndConditions) {
      this._sharedService.emmiterShowLoader(true)
      let data = {
        phone_code: '+' + this.indicativeSelected,
        user: this.numberPhone
      };
      let response: any = await this._loginInvitedService.getSmsCode(data).toPromise().catch((err: any) => this.handleError(err));
      if( response ){
        // this._amplitudeService.emmiterLogEvent('SUCCESS_SMS_CODE_GENERATED', {});
        console.log(response);
        this.optSelected = 2;
        this._sharedService.emmiterShowLoader(false)
        this.countdown();
      }
    } else toastr.warning('Debe aceptar los términos y condiciones.');
  }

  validateOnlyNumbers(): void {
    if(
      this._sharedService.validateOnlyNumbers(this.numberPhone) &&
      this.numberPhone.length > 7
      ){
      this.phoneValid = true;
    }else this.phoneValid = false;
    
  }

  showIndicatives(): void {
    let widthContainer = document.getElementsByClassName('container-input-indicative')[0].clientWidth;
    let list: any =  document.getElementsByClassName('list-indicatives')[0];
    list.style.width = widthContainer + 'px';
    this.statusSelectIndicative = true;
  }

  keyUp(id ?: any): void {

    this.code1 = this.code1.substr(0,1);
    this.code2 = this.code2.substr(0,1);
    this.code3 = this.code3.substr(0,1);
    this.code4 = this.code4.substr(0,1);
    this.code5 = this.code5.substr(0,1);

    if(this.code1 != '' && this.code2 != '' && this.code3 != '' && this.code4 != '' && this.code5 != '' ) this.codeValid = 2;
    else this.codeValid = 1;

    let inputCodeSix = (document.getElementById('code5') as HTMLInputElement);
    if(id == null || id == undefined){
      if(inputCodeSix.value.length > 1 ) inputCodeSix.value = inputCodeSix.value.charAt(1);
    }else{
      (document.getElementById(id) as HTMLInputElement).select();
      (document.getElementById(id) as HTMLInputElement).focus();
    }
  }

  async login() {
    this.codeValid = 3;
    let data = {
      indicative: '+' + this.indicativeSelected,
      phone: this.numberPhone,
      code: `${this.code1}${this.code2}${this.code3}${this.code4}${this.code5}`,
      modality: localStorage.getItem('modality')
    };
    let response: any = await this._loginInvitedService.loginUser(data).toPromise()
    .catch((err: any) => {
      this.codeValid = 2;
      if(err.error.message) {
        this._amplitudeService.emmiterLogEvent('FAIL_LOGIN', {
          MESSAGE: err.error.message
        });
        toastr.warning(err.error.message);
      } else this._amplitudeService.emmiterLogEvent('FAIL_LOGIN', {});
    });
    if( response && response.data && response.data.session ){
      localStorage.setItem('uid',        response.data.session.user_id)
      localStorage.setItem('token',      response.data.session.token)
      localStorage.setItem('user_phone', `+${this.indicativeSelected}${this.numberPhone}`)
      localStorage.setItem('session','true')

      if(response.data.user.address_id && response.data.session.user_invited) {

        // Guardar direccion y nombre
        this.optSelected = 3
        
      } else if(response.data.user.address_id && !response.data.session.user_invited) {
        
        // Guardar solo direccion
        this.optSelected = 4
        
      } else if(!response.data.user.address_id && response.data.session.user_invited) {
        
        // Guardar solo nombre
        this.optSelected = 5

      } else {
        this._loginInvitedService.emmiterLoginSuccess(true);
        this._checkoutService.getResumeOrderEmmiter(true);
        this._loginService.emmiterLoginSuccess(true);
        this.codeValid = 2;
        this.closeLogin();
        this._amplitudeService.initAmplitude();
        this._amplitudeService.emmiterLogEvent('SUCCESS_LOGIN', {
          'USER_PHONE': this.numberPhone
        });
      }

      // this.validateAddressTem();
      // ABRIR MODULO PARA SELECCIONAR DIRECCION
      // this.getAddress();
    }
  }

  validateFormAddressAndNameUser(): void {
    let data = {
      name_address: this.addressName.value,
      description: this.addressDescription.value,
      name_user: this.addressNameUser.value,
    };
    if(this.addressName.value != '' && this.addressDescription.value != '' && this.addressNameUser.value != ''){
      this.registerAddressUser(data)
    }
    else toastr.warning('Ingrese datos de dirección y usuario por favor.');
  }

  validateFormOnlyAddressUser(): void {
    let data = {
      name_address: this.addressName.value,
      description: this.addressDescription.value 
    };
    if(this.addressName.value != '' && this.addressDescription.value != ''){
      this.registerAddressUser(data)
    }
    else toastr.warning('Ingrese datos de dirección por favor.');
  }

  validateFormOnlyNameUser(): void {
    let data = {
      name_user: this.addressNameUser.value,
    };
    if(this.addressNameUser.value != ''){
      this.registerAddressUser(data)
    }
    else toastr.warning('Ingrese nombre de usuario por favor.');
  }

  async registerAddressUser(data: any) {

    let response: any = await this._loginInvitedService.updateAddressUser(data).toPromise()
    .catch((err: any) => {
      console.log('Error de login: ', err);
      if(err.error.message) toastr.warning(err.error.message);
    });
    if( response ){
      
      this._loginInvitedService.emmiterLoginSuccess(true);
      this._checkoutService.getResumeOrderEmmiter(true);
      this._loginService.emmiterLoginSuccess(true);
      this.closeLogin();

    }
  }

  closeLogin(): void {
    this._amplitudeService.emmiterLogEvent('CLOSE_LOGIN_CHECKOUT', {});
    this._loginInvitedService.emmiterShowLogin(false);
  }

  openTermsAndConditions(): void {
    let urlSiteIt = 'http://siteit.co/tyc.html';
    let urlBuffalo = 'https://as-siteitfoods-prod.azurewebsites.net/assets/pdfs/POLITICA-DE-TRATAMIENTO-DE-DATOS-PERSONALES-OFC-2018.pdf';
    // this._amplitudeService.emmiterLogEvent('OPEN_TERMS_AND_CONDITIONS', {
    //   URL: urlSiteIt 
    // });
    window.open(
      urlBuffalo,
      '_blank'
    );
    window.open(
      urlSiteIt,
      '_blank'
    );
  }

}
